import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Home from './view/home';
import Login from './view/login';

import TagListagem from './view/tag/listagem';
import TagCadastro from './view/tag/cadastro';

import Estatisticas from './view/estatisticas';
import PageNotFound from './view/page-not-found';
import ControleAcesso from './view/controle-acesso';
import ResumoEstatisticas from './view/resumo-estatisticas';

import PerfilListagem from './view/perfil/listagem';
import PerfilCadastro from './view/perfil/cadastro';

import UsuarioListagem from './view/usuario/listagem';
import UsuarioCadastro from './view/usuario/cadastro';

import OrganizacaoListagem from './view/organizacao/listagem';
import OrganizacaoCadastro from './view/organizacao/cadastro';

import ItemLicencaListagem from './view/item-licenca/listagem';
import ItemLicencaCadastro from './view/item-licenca/cadastro';

import LicencaBaseListagem from './view/licenca-base/listagem';
import LicencaBaseCadastro from './view/licenca-base/cadastro';

import LegendaOrigemListagem from './view/legenda-origem/listagem';
import LegendaOrigemCadastro from './view/legenda-origem/cadastro';

import LicencaOrganizacaoListagem from './view/licenca-organizacao/listagem';
import LicencaOrganizacaoCadastro from './view/licenca-organizacao/cadastro';
import LicencaOrganizacaoHistorico from './view/licenca-organizacao/historico';
import SelecaoLicencaBase from './view/licenca-organizacao/selecao-licenca-base';

import ConsultaLicencaOrganizacao from './view/consulta-licenca-organizacao/listagem';

import ParametroOrganizacaoListagem from './view/parametros-organizacao/listagem';
import ParametroOrganizacaoCadastro from './view/parametros-organizacao/cadastro';

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <Switch>
                        <Route exact path='/' component={Login} />
                        <Route exact path='/login' component={Login} />
                        <Route path='/login/:acao' component={Login} />
                        <Route exact path='/home' component={Home} />
                        <Route path='/home/:acao' component={Home} />

                        <Route exact path='/usuario' component={UsuarioListagem} />
                        <Route path='/usuario/pagina/:pagina' component={UsuarioListagem} />
                        <Route exact path='/usuario/novo' component={UsuarioCadastro} />
                        <Route path='/usuario/editar/:id' component={UsuarioCadastro} />
                        <Route path='/usuario/visualizar/:id/:action' component={UsuarioCadastro} />

                        <Route exact path='/perfil' component={PerfilListagem} />
                        <Route path='/perfil/pagina/:pagina' component={PerfilListagem} />
                        <Route exact path='/perfil/novo' component={PerfilCadastro} />
                        <Route path='/perfil/editar/:id' component={PerfilCadastro} />
                        <Route path='/perfil/visualizar/:id/:action' component={PerfilCadastro} />

                        <Route exact path='/tag' component={TagListagem} />
                        <Route path='/tag/pagina/:pagina' component={TagListagem} />
                        <Route exact path='/tag/novo' component={TagCadastro} />
                        <Route path='/tag/editar/:id' component={TagCadastro} />
                        <Route path='/tag/visualizar/:id/:action' component={TagCadastro} />

                        <Route exact path='/legendaorigem' component={LegendaOrigemListagem} />
                        <Route path='/legendaorigem/pagina/:pagina' component={LegendaOrigemListagem} />
                        <Route exact path='/legendaorigem/novo' component={LegendaOrigemCadastro} />
                        <Route path='/legendaorigem/editar/:id' component={LegendaOrigemCadastro} />
                        <Route path='/legendaorigem/visualizar/:id/:action' component={LegendaOrigemCadastro} />

                        <Route exact path='/organizacao' component={OrganizacaoListagem} />
                        <Route path='/organizacao/pagina/:pagina' component={OrganizacaoListagem} />
                        <Route exact path='/organizacao/novo' component={OrganizacaoCadastro} />
                        <Route path='/organizacao/editar/:id' component={OrganizacaoCadastro} />
                        <Route path='/organizacao/visualizar/:id/:action' component={OrganizacaoCadastro} />

                        <Route exact path='/itemlicenca' component={ItemLicencaListagem} />
                        <Route path='/itemlicenca/pagina/:pagina' component={ItemLicencaListagem} />
                        <Route exact path='/itemlicenca/novo' component={ItemLicencaCadastro} />
                        <Route path='/itemlicenca/editar/:id' component={ItemLicencaCadastro} />
                        <Route path='/itemlicenca/visualizar/:id/:action' component={ItemLicencaCadastro} />

                        <Route exact path='/organizacao/licenca/:idorganizacao' component={LicencaOrganizacaoListagem} />
                        <Route path='/organizacao/licenca/:idorganizacao/pagina/:pagina' component={LicencaOrganizacaoListagem} />
                        <Route exact path='/organizacao/licenca/:idorganizacao/novo' component={LicencaOrganizacaoCadastro} />
                        <Route exact path='/organizacao/licenca/:idorganizacao/novo/:idlicencabase' component={LicencaOrganizacaoCadastro} />
                        <Route path='/organizacao/licenca/:idorganizacao/editar/:id' component={LicencaOrganizacaoCadastro} />
                        <Route path='/organizacao/licenca/:idorganizacao/visualizar/:id/:action' component={LicencaOrganizacaoCadastro} />
                        <Route path='/organizacao/licenca/:idorganizacao/historico/:id' component={LicencaOrganizacaoHistorico} />
                        <Route path='/organizacao/:idorganizacao/licencabase/selecao' component={SelecaoLicencaBase} />

                        <Route exact path='/licencabase' component={LicencaBaseListagem} />
                        <Route path='/licencabase/pagina/:pagina' component={LicencaBaseListagem} />
                        <Route exact path='/licencabase/novo' component={LicencaBaseCadastro} />
                        <Route path='/licencabase/editar/:id' component={LicencaBaseCadastro} />
                        <Route path='/licencabase/visualizar/:id/:action' component={LicencaBaseCadastro} />

                        <Route exact path='/estatisticas' component={Estatisticas} />
                        <Route exact path='/resumoestatisticas' component={ResumoEstatisticas} />
                        <Route exact path='/controleacesso' component={ControleAcesso} />
                        <Route exact path='/consultalicencaorganizacao' component={ConsultaLicencaOrganizacao} />

                        <Route exact path='/organizacao/parametros/:idorganizacao' component={ParametroOrganizacaoListagem} />
                        <Route path='/organizacao/parametros/:idorganizacao/pagina/:pagina' component={ParametroOrganizacaoListagem} />
                        <Route exact path='/organizacao/parametros/:idorganizacao/novo' component={ParametroOrganizacaoCadastro} />
                        <Route path='/organizacao/parametros/:idorganizacao/editar/:id' component={ParametroOrganizacaoCadastro} />
                        <Route path='/organizacao/parametros/:idorganizacao/visualizar/:id/:action' component={ParametroOrganizacaoCadastro} />

                        <Route path='*' component={PageNotFound} />
                    </Switch>
                </Router>
            </PersistGate>
        </Provider>
    );
}

export default App;